import { render, staticRenderFns } from "./TimelineChat.vue?vue&type=template&id=431a950c&scoped=true"
import script from "./TimelineChat.vue?vue&type=script&lang=js"
export * from "./TimelineChat.vue?vue&type=script&lang=js"
import style0 from "./TimelineChat.vue?vue&type=style&index=0&id=431a950c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a950c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
